// @ts-check
/**
 * Typed client for the opportunities API.
 *
 * TYPES ARE GENERATED, NOT HAND-WRITTEN. See `schema.d.ts` header for details.
 *
 *     npm run generate:types-from-openapi-schema
 */
import axios from 'axios'

/** @typedef {import('./schema').components['schemas']} Schemas */

/** @typedef {Schemas['CheckEnrollmentRequest']} CheckEnrollmentRequest */
/** @typedef {Schemas['CheckEnrollmentResponse']} CheckEnrollmentResponse */

/**
 * POST /api/opportunities/check-enrollment/ — fetch a patient's enrolled opportunities.
 *
 * @param {CheckEnrollmentRequest} body
 * @param {import('axios').AxiosRequestConfig} [config]
 * @returns {Promise<CheckEnrollmentResponse>}
 */
export async function checkEnrollment(body, config) {
  const { data } = await axios.post('/api/opportunities/check-enrollment/', body, config)
  return data
}
